import { createSelector } from 'reselect';
import { initialState } from './reducer';
/**
 * Direct selector to the language domain
 */

const ribbon = (state) => (state && state.ribbon) || initialState;

/**
 * get ribbon loading state
 */
const selectRibbonLoading = () =>
  createSelector(ribbon, (ribbonState) => ribbonState.loading);

const selectRibbon = () =>
  createSelector(ribbon, (ribbonState) => ribbonState.view);
const selectRibbonError = () =>
  createSelector(ribbon, (ribbonState) => ribbonState.error);
const selectRibbonType = () =>
  createSelector(ribbon, (ribbonState) => ribbonState.typeView);
const selectRibbonHeight = () =>
  createSelector(ribbon, (ribbonState) => ribbonState.heightRibbon);
const selectSaveClick = () =>
  createSelector(ribbon, (ribbonState) => ribbonState.saveClick);
const selectMemberLayout = () =>
  createSelector(ribbon, (ribbonState) => ribbonState.layout);
// back route
const selectCanBackRoute = () =>
  createSelector(ribbon, (ribbonState) => ribbonState.canBackRoute);

const selectCloseDetailStack = () =>
  createSelector(ribbon, (ribbonState) => ribbonState.closeDetailStack);

const selectStoredDetailStack = () =>
  createSelector(ribbon, (ribbonState) => ribbonState.storedCloseDetailStack);

export {
  selectRibbon,
  selectRibbonLoading,
  selectRibbonError,
  selectRibbonType,
  selectRibbonHeight,
  selectSaveClick,
  selectCanBackRoute,
  selectMemberLayout,
  selectCloseDetailStack,
  selectStoredDetailStack,
};
